import { findDocumentElement, isHidden, isVisible } from './DomUtils';

const OpenMenuAction = {
  start(step) {
    const elt = findDocumentElement(step.button);
    if (elt) {
      elt.click();
      let timeout = step.timeout !== undefined ? step.timeout : 2000;
      const checkFrequency = step.checkFrequency || 20;
      const waitForOpen = step.waitForOpen !== undefined ? step.waitForOpen : 500;
      timeout += checkFrequency;

      return new Promise((resolve, reject) => {
        const checkElt = () => {
          const menu = findDocumentElement(step.popup);
          if (isVisible(menu)) {
            resolve([elt, menu]);
          } else {
            timeout -= checkFrequency;
            if (timeout <= 0) {
              reject(new Error(step.popup && `${step.popup.join(' ')} menu not openned` || 'no menu specified'));
            }
            setTimeout(checkElt, checkFrequency);
          }
        };
        if (waitForOpen) {
          setTimeout(checkElt, waitForOpen);
        } else {
          checkElt();
        }
      });
    }
    return Promise.reject(new Error(step.button && `${step.button.join()} not found` || 'No button defined'));
  },
  stop(step) {
    const elt = findDocumentElement(step.button);
    if (elt) {
      elt.click();
      let timeout = step.timeout !== undefined ? step.timeout : 2000;
      const checkFrequency = step.checkFrequency || 20;
      timeout += checkFrequency;

      return new Promise((resolve, reject) => {
        const checkElt = () => {
          const menu = findDocumentElement(step.popup);
          if (isHidden(menu)) {
            resolve([elt, menu]);
          } else {
            timeout -= checkFrequency;
            if (timeout <= 0) {
              reject(new Error(`Cannot close menu ${step.popup.join(' ')}`));
            }
            setTimeout(checkElt, 20);
          }
        };
        checkElt();
      });
    }
    return Promise.reject(new Error(step.button && `${step.button.join()} not found` || 'No button defined'));
  },
};

export default OpenMenuAction;
